import { FC } from 'react'
import clsx from 'clsx'
import { Auditoria } from '../core/_models'
import { formatDateTime, IconPaths, KTSVG } from '../../../../_metronic/helpers'

const LIMITE_HISTORICO = 20

type LoginAuditInfoProps = {
  auditoria?: Auditoria
}

export const LoginAuditInfo: FC<LoginAuditInfoProps> = ({ auditoria }) => {
  const detalhe = auditoria?.tentativasInvalidasDetalhe
  const tentativasInvalidas = detalhe ? detalhe.length : auditoria?.tentativasInvalidas ?? 0
  const recentesPrimeiro = detalhe ? [...detalhe].reverse() : []
  const historicoCheio = recentesPrimeiro.length >= LIMITE_HISTORICO

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Informações de Acesso</h3>
        </div>
      </div>

      <div className='card-body p-9'>
        <div className='row mb-7'>
          <label className='col-lg-4 fw-bold text-muted'>Último acesso com sucesso</label>

          <div className='col-lg-8 fv-row'>
            <span className='fw-bold fs-6'>{formatDateTime(auditoria?.ultimoAcesso)}</span>
          </div>
        </div>

        <div className={clsx('row', tentativasInvalidas > 0 && 'mb-7')}>
          <label className='col-lg-4 fw-bold text-muted'>
            Tentativas sem sucesso desde o último acesso
          </label>

          <div className='col-lg-8 fv-row'>
            <span className={clsx('fw-bold fs-6', tentativasInvalidas > 0 && 'text-danger')}>
              {historicoCheio ? `${LIMITE_HISTORICO} ou mais` : tentativasInvalidas}
            </span>
          </div>
        </div>

        {tentativasInvalidas > 0 && (
          <div
            className='notice d-flex rounded bg-light-danger p-5'
            style={{ borderLeft: '4px solid var(--bs-danger)' }}
            role='note'
          >
            <KTSVG path={IconPaths.Warning} className='svg-icon-2hx svg-icon-danger me-4' />

            <div className='flex-grow-1'>
              <span className='d-block fw-bold text-gray-900 fs-6 mb-1'>
                Foram identificadas tentativas de autenticação sem sucesso em seu usuário desde o
                último acesso.
              </span>
              <span className='d-block fs-7 text-gray-700'>
                Caso não reconheça essas tentativas, entre em contato com o suporte.
              </span>

              {recentesPrimeiro.length > 0 && (
                <div className='table-responsive mt-4'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2 mb-0 caption-top'>
                    <caption className='text-gray-700 fs-7 pt-0'>
                      {historicoCheio
                        ? `Exibindo as ${LIMITE_HISTORICO} tentativas mais recentes.`
                        : 'Da mais recente para a mais antiga.'}
                    </caption>
                    <thead>
                      <tr className='fw-bold text-gray-700 fs-7'>
                        <th scope='col'>Data e hora</th>
                        <th scope='col'>IP de origem</th>
                      </tr>
                    </thead>
                    <tbody>
                      {recentesPrimeiro.map((tentativa, indice) => (
                        <tr key={`${tentativa.dataHora}-${indice}`}>
                          <td className='fw-bold fs-6 text-gray-900'>
                            {formatDateTime(tentativa.dataHora)}
                          </td>
                          <td className='fs-6 text-gray-900'>{tentativa.ip ?? '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
